
import * as React from "react";

// Components
import Container from "../Container";

// Styles
import "./index.scss";

const Footer = () => {
  return (
    <div className="note">
      {/* <p>  </p> */}
      <p>   <a href="https://github.com/Nitish-d-Great" target="_blank">  </a> </p>
    </div>
  );
};

export default Footer;
